"use strict";

module.exports = function () {
	var numberIsNaN = Number.isNaN;
	if (typeof numberIsNaN !== "function") return false;
	return !numberIsNaN({}) && numberIsNaN(NaN) && !numberIsNaN(34);
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/number/is-nan/is-implemented.js
// module id = 737
// module chunks = 0